import { motion } from "framer-motion";
import { EASE, PRODUCTS } from "@/lib/site";
import { Nav } from "@/components/site/Nav";
import { Marquee } from "@/components/site/Marquee";
import { Footer } from "@/components/site/Footer";
import { Eyebrow } from "@/components/site/Reveal";
import { PickCard } from "@/components/home/PickCard";

const LINES = [["Products worth", false], ["your time,", true], ["picked honestly.", false]];
const PICKS = [
  { slug: "joint-genesis", no: "01", name: "Joint Genesis", tag: "Joint health", img: "/joint-genesis-doctor.webp", bg: "#0F2822", glow: "rgba(217,107,67,0.35)", accent: "#E5A93C", variant: "solid",
    blurb: "A daily capsule built around Mobilee® and botanicals, aimed at the cushioning fluid in your joints." },
  { slug: "prostavive", no: "02", name: "ProstaVive", tag: "Men's health", img: "/prostavive-jars.webp", bg: "#0B2A45", glow: "rgba(0,174,239,0.35)", accent: "#00AEEF", variant: "sky",
    blurb: "A one-scoop daily drink with 8 botanicals and 3 minerals for prostate, flow, sleep and energy support." },
  { slug: "nitric-boost", no: "03", name: "Nitric Boost", tag: "Male vitality", img: "/nitric-jars.webp", panel: true, bg: "#1A0D10", glow: "rgba(255,77,77,0.3)", accent: "#FF4D4D", variant: "crimson",
    blurb: "One scoop a day of 8 ingredients like beet root and L-Arginine, built around nitric oxide and blood flow." },
];
const HEADLINE = <>Start with the one <span className="font-serif italic font-normal text-[#D96B43]">you need.</span></>;

export default function Home() {
  return (
    <main className="bg-[#091D18]" data-testid="home-page">
      <Nav product={null} links={[["Picks", "#picks"]]} />
      <section className="relative overflow-hidden pb-16 pt-36 sm:pt-44" data-testid="home-hero">
        <div className="grain" />
        <div className="relative mx-auto max-w-7xl px-5 sm:px-8">
          <Eyebrow>gobbloo · Independent reviews by Rakesh Sharma</Eyebrow>
          <h1 className="mt-6 font-display text-[2.4rem] font-bold leading-[1] tracking-tight text-[#F2EDE4] sm:text-6xl lg:text-[5.2rem]" data-testid="home-headline">
            {LINES.map(([t, it], i) => (
              <span key={t} className="block overflow-hidden pb-[0.08em]">
                <motion.span className={`block ${it ? "font-serif text-[1.2em] leading-[0.9] italic font-normal text-[#D96B43]" : ""}`}
                  initial={{ y: "110%" }} animate={{ y: "0%" }} transition={{ duration: 1.2, ease: EASE, delay: 0.3 + i * 0.14 }}>
                  {t}
                </motion.span>
              </span>
            ))}
          </h1>
          <motion.p initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.9, duration: 1, ease: EASE }}
            className="mt-8 max-w-xl text-base leading-relaxed text-[#F2EDE4]/75 sm:text-lg">
            {Object.keys(PRODUCTS).length} health picks, each with a plain-English review. Pick the one that fits you and read before you buy.
          </motion.p>
        </div>
      </section>
      <section id="picks" className="relative pb-24 sm:pb-32" data-testid="home-picks">
        <div className="mx-auto grid max-w-7xl grid-cols-1 gap-5 px-5 sm:px-8 md:grid-cols-2 xl:grid-cols-3">
          {PICKS.map((p) => <PickCard key={p.slug} {...p} path={PRODUCTS[p.slug].path} />)}
        </div>
      </section>
      <Marquee items={["Joint Genesis", "ProstaVive", "Nitric Boost", "Honest reviews", "Plain-English notes", "More picks soon"]} />
      <Footer product={null} headline={HEADLINE} />
    </main>
  );
}
